import { nrkLogoNrkTv, nrkLogoNrkRadio, nrkLogoNrkP3 } from '@nrk/core-icons'

export function resolveLogo(lenke) {
  const { url } = lenke

  let logo
  if (lenke.visning === 'horisontal') {
    if (url.startsWith('https://p3.no/')) {
      logo = nrkLogoNrkP3
    } else if (url.startsWith('https://tv.nrk.no/')) {
      logo = nrkLogoNrkTv
    } else if (url.startsWith('https://radio.nrk.no/')) {
      logo = nrkLogoNrkRadio
    }
  }
  return logo
}
